// @ts-nocheck
// tslint:disable
/**
 * PalmApp Server Web API v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



// tslint:disable
import { APIModel, APIModelOptions, AttributeMapItem } from "../base";

export class MessageDto extends APIModel {
    /**
    * Message identifier
    */
    id: number;
    /**
    * Code of company
    */
    companyCode: string;
    /**
    * Name of company
    */
    companyName: string;
    /**
    * Message caption
    */
    caption: string;
    /**
    * Message type
    */
    type: string;
    /**
    * Message preview
    */
    preview: string;
    /**
    * Date of creation of message
    */
    created: string;
    /**
    * Date from which the message is valid
    */
    dateValidFrom: string;
    /**
    * Date until which the message is valid
    */
    dateValidTo: string;

    constructor(options?: APIModelOptions) {
        super(MessageDto.attributeTypeMap, options);
    }

    static get attributeTypeMap(): Array<AttributeMapItem> {
        return [
            { name: "id", type: "number" },
            { name: "companyCode", type: "string" },
            { name: "companyName", type: "string" },
            { name: "caption", type: "string" },
            { name: "type", type: "string" },
            { name: "preview", type: "string" },
            { name: "created", type: "string" },
            { name: "dateValidFrom", type: "string" },
            { name: "dateValidTo", type: "string" }
        ];
    }
}




